<template>
  <div class="test-details-bottom">

    <div class="item">
      <app-text-input
        :label="$ml.get(`Layer depth`)"
        v-model="form.layer_depth"
        type="number"
        min="0"
        hint="cm_inch"
      />
    </div>
    <div class="item">
      <app-text-input
        :label="$ml.get(`Average temperature`)"
        v-model="form.avg_temp"
        type="number"
        min="0"
        hint="C"
      />
    </div>
    <div class="item">
      <app-text-input
        :label="$ml.get(`CEC`)"
        v-model="form.cec"
        type="number"
        min="0.01"
        hint="meq/100g"
        :info-tip="$ml.get('CEC (Cation Exchange Capacity)')"
      />
    </div>
    <div class="item">
      <app-text-input
        :label="$ml.get(`Bulk density`)"
        v-model="form.bulk"
        type="number"
        min="0"
        hint="g/cm3"
      />
    </div>
    <div class="item">
      <app-text-input
        :label="$ml.get(`EC`)"
        v-model="form.ec"
        type="number"
        min="0"
        hint="dS/m"
        :info-tip="$ml.get('EC (Electrical Conductivity)')"
      />
    </div>
    <div class="item">
      <app-text-input
        label="pH"
        v-model="form.ph"
        type="number"
        min="0"
        max="14"
      />
    </div>
    <div class="item">
      <app-text-input
        :label="$ml.get(`OM`)"
        v-model="form.om"
        type="number"
        min="0"
        hint="%"
        :info-tip="$ml.get('OM (Organic Matter)')"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
 
  data() {
    return {
     
    }
  },
  methods: {

  },
  computed: {
    ...mapGetters({
      form: 'tests/soil/form'
    }),
  },
}
</script>

<style lang="scss" scoped>

.test-details-bottom {

  margin-top: 30px;
  padding-top: 10px;
  border-top: 1px solid #E4E5E6;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;

  .item {
    width: 50%;
    margin-top: 30px;
    padding: 0 10px;

    display: flex;
    align-items: center;
    justify-content: center;

    > * {
      width: 100%;
    }
  }
}

</style>
